<template>
    <div>
        <v-container fluid>
            <router-view></router-view>
        </v-container>
    </div>
</template>
<script>
export default {
    data: () => ({}),
    methods: {}
};
</script>